function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_63",
  "data-name": "Gruppe 63",
  transform: "translate(-107 -24)"
}, /*#__PURE__*/React.createElement("text", {
  id: "Personalentwicklung_Mainfranken",
  "data-name": "Personalentwicklung Mainfranken",
  transform: "translate(218 56)",
  fill: "#161615",
  fontSize: 21,
  fontFamily: "Silka-Medium, Silka",
  fontWeight: 500
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Personalentwicklung"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 25
}, "Mainfranken")), /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_60",
  "data-name": "Gruppe 60",
  transform: "translate(3.695 -73.763)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_294",
  "data-name": "Pfad 294",
  d: "M117.15,138.46l5.039-4.959,4.471,4.391v.977l3.807-1.117v-3.734l3.408-3.092V126.9h4.841v4.014l3.64,3.134v3.033l20.362,3.218V135.94l3.731-3.732,3.875,3.72v11.878l3.322,3.323.528-.527a37.164,37.164,0,1,0-69.758-6.636l12.734-3.723Z",
  fill: "#e71d36"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_295",
  "data-name": "Pfad 295",
  d: "M168.324,136.78l-1.847-1.772-1.759,1.76v5.869l-24.362-3.85v-3.825l-3.64-3.134V128.9h-.841v2.915l-3.408,3.092v4.344l-7.807,2.293V138.73l-2.469-2.424L119.15,139.3v2.444l-14.2,4.152a37.171,37.171,0,0,0,67.9,7.271l-4.53-4.531Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_296",
  "data-name": "Pfad 296",
  d: "M173.646,151.129l-3.322-3.323V135.928l-3.875-3.72-3.731,3.732V140.3l-20.362-3.218v-3.033l-3.64-3.134V126.9h-4.841v4.029l-3.408,3.092v3.734l-3.807,1.117v-.977l-4.471-4.391-5.039,4.959v1.783l-12.734,3.723c.163.649.339,1.293.534,1.928l14.2-4.152V139.3l3.041-2.992,2.469,2.424v2.811l7.807-2.293V134.9l3.408-3.092V128.9h.841v2.931l3.64,3.134v3.825l24.362,3.85v-5.869l1.759-1.76,1.847,1.772v11.854l4.53,4.531q.708-1.252,1.32-2.563Z"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 74.334,
    viewBox: "0 0 330 74.334",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo.13a83dda.svg";
export { ForwardRef as ReactComponent };